<div *ngIf="errorMsgs.length == 0">
	<div class="overflow-x">
		<app-data-table
			[PAGE_SIZE]="PREVIEW_TABLE_PAGE_SIZE"
			[dataSource]="dataSource"
			[dataType]="DATA_TYPE"
			[displayedColumns]="PREVIEW_TABLE_COLUMNS"
			[isStaticPagination]="true"
			[tableHeaders]="PREVIEW_TABLE_HEADERS"
			[tableIcons]="TABLE_ICONS"
			[totalNumberOfRecords]="
				isDataTypeRFP || isDataTypeProject
					? environment.RFP_PREVIEW_TABLE_ROWS_LIMIT
					: !utilService.isNullOrUndefined(allLines)
					? allLines.length
					: 0
			"
		>
		</app-data-table>
	</div>
</div>

<div *ngIf="errorMsgs.length > 0">
	<div>
		<ul class="font-size-13 danger-text">
			<li *ngFor="let error of errorMsgs">{{ error }}</li>
			<br />
		</ul>
	</div>
</div>
